import styled from '@emotion/styled';
import { BackButton, Title } from 'components';

export const ProductContainer = styled.div`
    position: absolute;
    top: 0;
    z-index: 1;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: ${({ theme }) => theme.base.color.backgroundMain};
`;

export const AbsoluteBackButton = styled(BackButton)`
    position: absolute;
    top: ${({ theme }) => theme.base.spacing[4]};
    left: ${({ theme }) => theme.base.spacing[4]};
`;

export const ProductTitle = styled(Title)`
    margin-bottom: ${({ theme }) => theme.base.spacing[2]};
`;

export const AdditionalInformation = styled(Title)`
    margin-top: ${({ theme }) => theme.base.spacing[6]};
    margin-bottom: ${({ theme }) => theme.base.spacing[1]};
`;

export const ProductImage = styled.div<{ url: string }>`
    height: 250px;
    width: 100%;
    background-position: center center;
    background-size: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url('${({ url }) => url}');
`;
export const ProductContentContainer = styled.div`
    flex: 1;
    padding: ${({ theme }) => theme.base.spacing[4]};
`;

export const Spacer = styled.div`
    height: 65px;
`;

export const BottomBar = styled.div`
    background: ${({ theme }) => theme.base.color.backgroundMain};
    padding: ${({ theme }) => theme.base.spacing[4]};
    height: 90px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
